// @flow
import { uuidPattern } from './constants';

const sanitiseUUID = (uuid) => uuid.replace(uuidPattern, '');

export default sanitiseUUID;
